export default function TermsPage() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-white mb-8">Terms of Service</h1>

        <div className="prose prose-invert prose-zinc max-w-none">
          <p className="text-zinc-400 text-lg mb-8">
            Last updated: January 2026
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-zinc-400">
              By accessing or using WiserWebCloud services, you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">2. Description of Services</h2>
            <p className="text-zinc-400 mb-4">
              WiserWebCloud provides cloud hosting services including but not limited to:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Application deployment and hosting</li>
              <li>Virtual Private Servers (VPS)</li>
              <li>Object storage (S3-compatible)</li>
              <li>DNS management</li>
              <li>Database services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">3. Account Responsibilities</h2>
            <p className="text-zinc-400 mb-4">
              You are responsible for:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Ensuring your use complies with all applicable laws</li>
              <li>Keeping your contact and billing information current</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">4. Acceptable Use</h2>
            <p className="text-zinc-400 mb-4">
              You agree not to use our services to:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Distribute malware or malicious code</li>
              <li>Send spam or unsolicited communications</li>
              <li>Engage in cryptocurrency mining without authorization</li>
              <li>Host content that is illegal, harmful, or objectionable</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">5. Service Level Agreement</h2>
            <p className="text-zinc-400">
              We strive to maintain 99.9% uptime for our services. Scheduled maintenance windows will be communicated in advance. Service credits may be issued for verified downtime exceeding our SLA commitments.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">6. Payment Terms</h2>
            <p className="text-zinc-400 mb-4">
              Billing is processed monthly or annually based on your subscription. All fees are non-refundable except as required by law. We reserve the right to modify pricing with 30 days notice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">7. Termination</h2>
            <p className="text-zinc-400">
              Either party may terminate this agreement at any time. Upon termination, you must cease using our services and we may delete your data after a 30-day grace period. We may suspend or terminate accounts that violate these terms without notice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">8. Limitation of Liability</h2>
            <p className="text-zinc-400">
              To the maximum extent permitted by law, WiserWebCloud shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">9. Changes to Terms</h2>
            <p className="text-zinc-400">
              We may update these terms from time to time. We will notify you of material changes via email or through our services. Continued use after changes constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">10. Contact</h2>
            <p className="text-zinc-400">
              For questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:legal@wiserwebcloud.com" className="text-orange-400 hover:text-orange-300">
                legal@wiserwebcloud.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
